
// Owa Public Path Plugin
if (typeof self !== "undefined" && self.bootstrapOptions && self.bootstrapOptions.scriptBaseUrl) {
	__webpack_require__.p = self.bootstrapOptions.scriptBaseUrl;
}